export const ENV = {
  REACT_APP_APOLLO_GRAPHQL_URL: "REACT_APP_APOLLO_GRAPHQL_URL_PLACEHOLDER",
  REACT_APP_AUTH0_DOMAIN: "REACT_APP_AUTH0_DOMAIN_PLACEHOLDER",
  REACT_APP_AUTH0_CLIENT_ID: "REACT_APP_AUTH0_CLIENT_ID_PLACEHOLDER",
  REACT_APP_WEBHOOK_URL: "REACT_APP_WEBHOOK_URL_PLACEHOLDER",
}
